import { useState } from 'react'
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import SortableRequestRow from './SortableRequestRow'

const STATUS_COLORS = {
  'idea': 'bg-slate-500/20 text-slate-300 border-slate-500/40',
  'in-progress for future release': 'bg-yellow-500/20 text-yellow-300 border-yellow-500/40',
  'ready for release': 'bg-blue-500/20 text-blue-300 border-blue-500/40',
  'released': 'bg-green-500/20 text-green-300 border-green-500/40',
}

const STATUS_TOP_BORDER = {
  'idea': 'border-t-slate-500/40',
  'in-progress for future release': 'border-t-yellow-500/40',
  'ready for release': 'border-t-blue-500/40',
  'released': 'border-t-green-500/40',
}

function CollapsibleStatusGroup({ id, title, requests, userRole, canEdit, onPriorityChange }) {
  const [isExpanded, setIsExpanded] = useState(true)

  const itemIds = requests.map((r) => r.link_id)
  const statusColor = STATUS_COLORS[id] || STATUS_COLORS.idea
  const topBorderColor = STATUS_TOP_BORDER[id] || STATUS_TOP_BORDER.idea

  return (
    <div className={`bg-xano-card rounded-lg border border-xano-border border-t-4 ${topBorderColor}`}>
      {/* Collapsible Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center gap-3 px-4 py-3 hover:bg-xano-cardHover transition-colors text-left"
      >
        {/* Chevron */}
        <svg
          className={`w-4 h-4 text-xano-textMuted transition-transform ${isExpanded ? 'rotate-90' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>

        {/* Status Badge */}
        <span className={`px-3 py-1 text-sm font-medium border rounded ${statusColor}`}>
          {title}
        </span>

        {/* Count */}
        <span className="text-sm text-xano-textMuted">
          {requests.length}
        </span>
      </button>

      {/* Expandable Content */}
      {isExpanded && requests.length > 0 && (
        <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
          <div className="pb-2">
            {requests.map((request) => (
              <SortableRequestRow
                key={request.link_id}
                request={request}
                userRole={userRole}
                canEdit={canEdit}
                onPriorityChange={onPriorityChange}
              />
            ))}
          </div>
        </SortableContext>
      )}
    </div>
  )
}

export default CollapsibleStatusGroup
